module.exports = __webpack_public_path__ + "static/playerOne-4c827f652d6e373ffb6c95f5de6b488d.gif";